import { getReferral } from '@office-start/telemetry-utility';
import { logUserAction } from './logUserAction';
export function logReferUserAction(actionId, area, referral, subArea, actionType, eventName) {
    logUserAction({
        id: actionId,
        area: area,
        subArea: subArea ? subArea : 'Other',
        result: referral ? 'Refer' : 'Navigate',
        target: referral ? getReferral(referral) : 'Other',
        type: actionType ? actionType : 'Click',
        targetId: referral ? referral : '',
        eventName: eventName ? eventName : '',
    });
}
//# sourceMappingURL=logReferUserAction.js.map